export default __webpack_public_path__ + "static/media/558.2d118001.png";